<template>
  <!-- InnovationPage-->
  <div
    id="top"
    class="w-100 space-for-navbar mb-3"
  >
    <div
      id="SplashContainer"
      class="m-0 p-0 centered-on-page"
    >
      <div class="m-0 p-0 w-100 h-100">
        <svg
          class="m-0 p-0"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 1000 560"
        >
          <title>Science</title>
          <g id="Splashes">
            <g id="Innovation">
              <image
                id="banner1"
                width="1000"
                height="560"
                transform="translate(0, 0)"
                :xlink:href="require('../assets/splashes/SplashInnovation1.jpg')"
              />
              <g id="InnovationLabel1">
                <text
                  class="bmg-splashes-15"
                  transform="translate(345 230)"
                >Innovation</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(325 260)"
                >Define Engineering</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(370 290)"
                >Envelope for</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(362 320)"
                >Improvement</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(360 350)"
                >Breakthrough</text>
              </g>
              <image
                id="banner2"
                width="1000"
                height="560"
                transform="translate(0, 0)"
                :xlink:href="require('../assets/splashes/SplashInnovation2.jpg')"
              />
              <g id="InnovationLabel2">
                <text
                  class="bmg-splashes-15"
                  transform="translate(220 205)"
                >Innovation</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(220 235)"
                >Invent</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(220 265)"
                >Improvement</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(220 295)"
                >Breakthrough</text>
              </g>
              <image
                id="banner3"
                width="1000"
                height="560"
                transform="translate(0, 0)"
                :xlink:href="require('../assets/splashes/SplashInnovation3.jpg')"
              />
              <g id="InnovationLabel3">
                <text
                  class="bmg-splashes-15"
                  transform="translate(350 225)"
                >Innovation</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(385 255)"
                >Design, Test</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(370 285)"
                >and Optimize</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(370 315)"
                >Breakthrough</text>
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
    <!-- Performance Criteria -->
    <section class="my-3">
      <!-- Section heading -->
      <h1 class="h1 text-center text-dark font-weight-bold my-3">
        Performance Criteria
      </h1>
      <!-- Section description -->
      <div class="container-fluid w-80">
        <div class="row">
          <div class="col-lg-12 col-lg-6 col-xl-5 mx-auto my-auto">
            <p class="lead text-dark w-responsive mx-auto mb-2">
              <ul class="h4 mx-3">
                <li>
                  Sustain optimal fracture zone compression during and after osteoclastic
                  resorption of necrotic bone that has died on both sides of the fracture
                </li>
                <li>
                  Compression induced intimate surface remodeli
                  <ul class=" h5 mx-3">
                    <li>
                      Maximizes fracture zone contact and minimizes gaps
                    </li>
                    <li>
                      Facilitates extensive, immediate Haversian Remodeling
                    </li>
                  </ul>
                </li>
                <li>
                  Compression that sustains fracture stability for weight bearing and
                  exercise (even after fixating high impact fractures)
                  <ul class=" h5 mx-3">
                    <li>
                      Reduces or eliminates hardware failure
                    </li>
                    <li>
                      Avoids root cause of atrophy, malunion and non-union and
                      associated predisposition to further complications
                    </li>
                  </ul>
                </li>
                <li>
                  Personalized stress shielding (bone-healing-rate based)
                  <ul class=" h5 mx-3">
                    <li>
                      Gradually declines according to fracture regrowth
                    </li>
                  </ul>
                </li>
                <li>
                  Reliably achieve all the foregoing,
                  <ul class=" h5 mx-3">
                    <li>
                      Even for high-energy fractures
                    </li>
                  </ul>
                </li>
              </ul>
            </p>
          </div>
          <div class="col-lg">
            <!-- Card deck -->
            <div class="card-deck">
              <!-- Card -->
              <div class="card mb-4">
                <!--Card image-->
                <div class="view overlay">
                  <img
                    class="card-img-top"
                    src="../assets/purchased_pics/iStock-154954447.jpg"
                    alt="World Market"
                  >
                  <a href="#!">
                    <div class="mask rgba-white-slight" />
                  </a>
                </div>
                <!--Card content-->
                <div class="card-body">
                  <!--Title-->
                  <h4 class="card-title">
                    Conventional implants do not achieve these criteria and consequently<br>
                    <ul class="ml-3 mt-2">
                      <li class="m1">
                        Surgical repair may not be attempted, and the horse euthanized
                      </li>
                      <li>Plates may be broken</li>
                      <li>
                        Repairs or subsequent revisions may be so painful that the horse is expected to
                        refuse bearing weight on the limb leading to injury of the contralateral limb.
                      </li>
                    </ul>
                  </h4>
                  <!--Text-->
                  <!-- <p class="card-text">Disruptive Capture Anticipated</p> -->
                </div>
              </div>
              <!-- End Card -->
              <!-- Card -->
              <div class="card mb-4">
                <!--Card image-->
                <div class="view overlay">
                  <img
                    class="card-img-top"
                    src="../assets/purchased_pics/shutterstock_1023277171_transparent_background.png"
                    alt="Annual Growth"
                  >
                  <a href="#!">
                    <div class="mask rgba-white-slight" />
                  </a>
                </div>
                <!--Card content-->
                <div class="card-body">
                  <!--Title-->
                  <h4 class="card-title">
                    Failure of conventional implants to meet these criteria in humans
                    <ul class="ml-3 mt-2">
                      <li class="m1">
                        Adds 2 to 5 months of healing time
                      </li>
                      <li>
                        4 to 16 weeks with restricted weight bearing and exercise causes
                        atrophy (reduction of size and strength) of bones, muscles, ligaments
                        &amp; tendons.
                      </li>
                      <li>Elderly patients with major fractures may never recover</li>
                    </ul>
                  </h4>
                </div>
              </div>
              <!-- End Card -->
            </div>
            <!-- End Card deck -->
          </div>
        </div>
      </div>
    </section>
    <!-- End Performance Criteria -->
    <!-- Product Line Progress -->
    <div class="container-fluid w-100 my-3">
      <img
        class="img-fluid w-100"
        src="../assets/business_pics/ProductLineProgress.jpg"
      >
    </div>
    <!-- END Product Line Progress -->
    <!-- Initial Product Lines -->
    <div
      id="initial-product-lines"
      class="container-fluid bmg-large-section-white w-90 z-depth-5 p-5"
    >
      <div class="row centered-on-page">
        <div class="col-lg py-3 py-lg-0">
          <div class="row">
            <div class="col-5 centered-on-page">
              <div class="">
                <h1 class="h1 my-4 text-right">
                  Initial Product Lines
                </h1>
                <h3 class="h4 text-right">
                  Addressing a Wide<br>Range of Bone<br>Fracture Repair<br>Procedures
                </h3>
              </div>
            </div>
            <div class="col-2 bg centered-on-page">
              <div class="bg-dark w-10 h-100">
&nbsp;
              </div>
            </div>
            <div class="col-5 h5">
              <ul class="ml-xs-3 ml-lg-2 px-0 my-3 text-left">
                <li>Foot Bones</li>
                <li>Ankles</li>
                <li>Shoulder blade</li>
                <li>Collarbone</li>
                <li>Lower Forearm bones</li>
                <li>Hand</li>
                <li>Pelvis</li>
                <li>Thighbone</li>
                <li>Leg bones</li>
                <li>Kneecap</li>
                <li>
                  Equine Long bones
                  <ul>
                    <li>Tibia</li>
                    <li>Radius</li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-lg bg-dark text-white centered-on-page">
          <div>
            <h2 class="h1 my-4 text-center">
              Spring-Enhanced Orthopedic Hardware
            </h2>
            <ul class="text-left h4 mb-3">
              <li>Spring Screws</li>
              <li>
                Bone Plates
                <ul>
                  <li>Compression</li>
                  <li>Bridging</li>
                </ul>
              </li>
              <li>
                Bone Sutures-micro cables
                <ul>
                  <li>Installed inside the bone</li>
                  <li>1 to 4 mm below the periosteum</li>
                  <li>Longitudinally</li>
                  <li>Circumferentially</li>
                </ul>
              </li>
              <li>
                Specialty Hardware
                <ul>
                  <li>Calcaneal Ligamentotaxis</li>
                  <li>Integrate springs in devices patented by others</li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- End Initial Product Lines -->
    <!-- Most Fundamental Improvement -->
    <section class="bmg-half-page-section-view-white mx-4 z-depth-1 p-3 centered-on-page">
      <div class="">
        <div class="row">
          <div class="col-md-4">
            <div class="view rounded">
              <img
                src="../assets/hardware_pics/ScrewHeads.png"
                class="img-fluid"
                alt="BMG Logo"
              >
              <div class="mask flex-center hm-gradient" />
            </div>
          </div>
          <div class="col-md">
            <div class="d-flex flex-column justify-content-center align-items-center h-100 mb-3">
              <h1 class="h1 mb-3 text-center">
                Most Fundamental Improvement in Bone Screws in <em>90 Years</em>
              </h1>
              <h2 class="mb-3 text-center">
                <strong>
                  New Generation Technology Applied to Full Range of Screws
                </strong>
              </h2>
              <h3 class="text-center">
                Belleville spring washers
                <hr class="my-3 mdb-color w-50">
                Bearing washer
                <hr class="mb-3 mdb-color w-50">
                All slide on the shank
                <hr class="mb-3 mdb-color w-50">
                Tightening compresses spring washers
                <hr class="mb-3 mdb-color w-50">
                Spring washers extend, sustaining compression
                <hr class="mb-3 mdb-color w-50">
                Unique &amp; patent pending
                <hr class="mb-3 mdb-color w-50">
                Fabricated &amp; mechanically proven
              </h3>
            </div>
          </div>
        </div>
        <div class="">
          <img
            class="img-fluid w-100"
            src="../assets/medical_pics/BMGInventedHardwareToCloseResorptionGaps.jpg"
          >
        </div>
        <div class="my-2">
          <img
            class="img-fluid w-100"
            src="../assets/medical_pics/FullEarlyWeightBearingBenefits.jpg"
          >
        </div>
      </div>
    </section>
    <!-- END Most Fundamental Improvement -->
    <!-- Bone Plates -->
    <!-- Card -->
    <div class="card card-cascade wider reverse my-5 centered-on-page ">
      <!-- Card image -->
      <div class="view view-cascade overlay">
        <img
          class="card-img-top"
          src="../assets/purchased_pics/shutterstock_527869648_Legs_Only.jpg"
          alt="Card image cap"
        >
        <a href="#!">
          <div class="mask rgba-white-slight" />
        </a>
      </div>
      <!-- Card content -->
      <div class="card-body card-body-cascade text-white bg-dark mw-75">
        <div class="centered-on-page">
          <span class="h1 my-0 py-0 mr-5 text-right">Bone Plates</span>
          <span class="h1 bg-white">&nbsp;</span>
          <span class="h2 my-0 py-0 ml-5">Testing Equine Tibia Long-bone Repair in Vivo</span>
        </div>
        <div class="my-3 centered-on-page">
          <div class="w-80">
            <div class="row">
              <div class="col-2">
                <img
                  class="img-fluid rounded"
                  src="../assets/bio_pics/JanikGasiorowski.jpg"
                >
              </div>
              <div class="h3 col-10">
                <font-awesome-icon
                  icon="quote-left"
                  size="1x"
                  class="text-secondary"
                /> Stability is comfort and, due to the threat of support limb laminitis, comfort is survival
                in fracture repair in the horse. Comfort comes from sustained compression. Technological
                innovations by Bridging Medical expects to provide sustained compression and survival where current
                instrumentation does not. <font-awesome-icon
                  icon="quote-right"
                  size="1x"
                  class="text-secondary"
                /> 
              </div>
            </div>
            <div class="h3 font-weight-bold centered-on-page">
              <span class="">Janik C. Gasiorowski, VMD, DACVS</span>
              <ul class="h5">
                <li>
                  AOVET Faculty, Mid-Atlantic Equine Medical Center Owner, Operator, Equine Surgeon
                </li>
                <li>
                  BMG Medical Board, Co-Primary Investigator, BMG Investor
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div
        id="tibia-repair"
        class="my-2 w-100 centered-on-page"
      >
        <img
          class="img-fluid w-90"
          src="../assets/medical_pics/BMG_Equine_Bone_Plate_D2.jpg"
        >
      </div>
    </div>
    <!-- Card -->
    <!-- END Bone Plates -->
    <!-- Bone Sutures -->
    <div
      id="bone-sutures"
      class="container-fluid bmg-large-section-white w-95 z-depth-5 mx-4 p-5"
    >
      <div class="py-3 py-lg-0">
        <div class="row">
          <div class="col-md-7">
            <div class="row centered-on-page">
              <div class="col-lg m-0 p-0 my-2">
                <img
                  class="img-fluid"
                  src="../assets/medical_pics/Sutures.png"
                >
              </div>
              <div class="col-lg m-0 p-0">
                <ul class="h4 text-left">
                  <li>Installed inside the bone, with directional micro drilling</li>
                  <li>
                    About 1 to 4 mm below the periosteum
                    <ul>
                      <li>Longitudinally</li>
                      <li>Circumferentially</li>
                    </ul>
                  </li>
                  <li>
                    Surgically creates ultra bone-hardware construct
                    <ul>
                      <li>With about 50% of pre-fractured bone strength</li>
                    </ul>
                  </li>
                  <li>
                    More uniformly distributes compression
                    <ul>
                      <li>Than plates or screws</li>
                    </ul>
                  </li>
                  <li>Can be permanently left in place</li>
                  <li>
                    Easily removed with minimal surgery
                    <ul>
                      <li>At mid-stage healing</li>
                      <li>Enables Haversian Remodeling of the bone purchase</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-2 bg centered-on-page">
            <div class="bg-dark w-xs-100 h-xs-10 w-md-10 h-md-100">
&nbsp;
            </div>
          </div>
          <div class="col-md-3 centered-on-page">
            <div class="">
              <h1 class="display-3 my-4 text-left ">
                Bone Sutures
              </h1>
              <h1 class="text-left">
                Micro-invasively installed micro cables
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Bone Sutures -->
    <!-- Revolutionary Concept -->
    <section class="container-fluid my-5 w-95 border">
      <!-- Section heading -->
      <h2 class="h1 font-weight-bold text-dark text-center mt-5">
        A Truly Revolutionary Concept in Orthopedic Hardware
      </h2>
      <!-- Section description -->
      <p class="h2 text-center w-responsive mx-auto my-2">
        Example of Proposed Bone Suture Repair of Distal Tibial Fracture
      </p>
      <!-- <p class="h5 grey-text text-center w-responsive mx-auto mb-5">sub-sub-heading</p> -->
      <!-- Grid row -->
      <div class="row">
        <div class="col-lg-5 text-center text-lg-left bg-white centered-on-page">
          <img
            class="img-fluid"
            src="../assets/medical_pics/SuturesZoom.png"
            alt="Sample image"
          >
        </div>
        <!-- Grid column -->
        <div class="col-lg-7 h4">
          <!-- Grid row -->
          <div class="row mb-3 mt-3">
            <!-- Grid column -->
            <div class="col-1 pt-3">
              <font-awesome-icon
                icon="share"
                size="2x"
                class="text-primary"
              />
            </div>
            <!-- Grid column -->
            <div class="col-xl-10 col-md-11 col-10 pt-3">
              <h5 class="h3 font-weight-bold text-primary mb-3">
                Sustains compression with more efficient percutaneous fixation and enables early weight bearing
              </h5>
              <p class="dark-grey-text">
                <ul class="">
                  <li>
                    Our technology allows for a suture wire type of fixation to
                    be strategically placed inside the bone, along the fracture
                    zone, with tension dynamically sustained, holding bones in
                    place with optimal, sustained compression.
                  </li>
                  <li>
                    This is expected to allow for a simple fracture repair as well as a
                    buttress style repair for more comminuted fractures.
                  </li>
                  <li>
                    These technologies are anticipated to greatly enhance the patient’s
                    ability to return to activities and are expected to provide a more
                    efficient percutaneous fixation technique.
                  </li>
                </ul>
              </p>
            </div>
          </div>
          <div class="row mb-3">
            <!-- Grid column -->
            <div class="col-1">
              <font-awesome-icon
                icon="share"
                size="2x"
                class="text-primary"
              />
            </div>
            <!-- Grid column -->
            <div class="col-xl-10 col-md-11 col-10">
              <h5 class="h3 font-weight-bold text-primary mb-3">
                In Addition to Rendering Plates and Screws Dynamic with
                Micro-Springs Bridging Medical is Developing New Generation
                Hardware that:
              </h5>
              <p class="dark-grey-text">
                <ul class="m-0">
                  <li>
                    Is Micro-invasively installed inside the bone
                    <ul>
                      <li>
                        As opposed to the typical highly invasive bone plates,
                        that are necessarily installed outside the bone surface,
                        invading and degrading the fleshy tissue composed of
                        muscles, ligaments, tendons, blood supply systems,
                        neurovascular bundles, skin, etc.
                      </li>
                      <li>
                        And as opposed to intermedullary nails that are highly
                        invasive to the interior bone and blood supply, and do
                        not sustain bone fracture compression nor primary growth.
                      </li>
                    </ul>
                  </li>
                  <li>
                    Gradually reduces stress shielding as bone fracture regrowth strength increases
                    <ul>
                      <li>Until stress shielding reaches zero, when shielding is no longer healthful.</li>
                      <li>Traditional hardware either rapidly loosens and fails to healthfully shield the bone to enable high-early loading, exercise, increased blood flow and primary healing</li>
                      <li>Or traditional hardware continues to shield bone far after healing, causing bone atrophy, osteoporosis and chronic bone weakness at the locations of shielding hardware</li>
                    </ul>
                  </li>
                  <li>
                    Can easily be removed with minimal surgery or be permanently left in place.
                    <ul>
                      <li>Rapid primary healing may create opportunity for bone suture removal by 4 to 6 weeks resulting in little or no evidence of fracture</li>
                    </ul>
                  </li>
                </ul>
              </p>
            </div>
            <!-- Grid column -->
          </div>
          <!--Grid row-->
        </div>
      </div>
      <div class="h3 text-primary text-center w-responsive mx-auto my-2 w-50">
        <em>
          BMG Could Actually Achieve the 90+ Year-Old Vision for Internal Fixation
          in a Substantially Greater Number of Fractures!
        </em>
      </div>
      <!-- Grid row -->
    </section>
    <!-- END Revolutionary Concept -->
  </div>
  <!-- End of InnovationPage-->
</template>

<script>
import SecurityCheckMixin from './mixins/SecurityCheckMixin'
// import {TimelineMax, CSSPlugin, AttrPlugin} from 'gsap/all'
import 'gsap'

// Make sure babel doesn't trim the plugins from the DOM tree
// const plugins = [ CSSPlugin, AttrPlugin ]

export default {
  mixins: [SecurityCheckMixin],
  name: 'InnovationPage',
  computed: {},
  components: {},
  methods: {
    rotateBanner: function () {
      var banner = new TimelineMax({
        paused: false,
        repeat: -1,
        repeatDelay: 0,
        yoyo: false
      })
      banner.to('#banner2, #banner3, #InnovationLabel2, #InnovationLabel3', 0, {opacity: 0})
        .to('#banner1, #InnovationLabel1', 5, {opacity: 1})
        .to('#banner1, #InnovationLabel1', 1, {opacity: 0})
        .to('#banner2, #InnovationLabel2', 1, {opacity: 1}, '-=1')
        .to('#banner2, #InnovationLabel2', 5, {opacity: 1})
        .to('#banner2, #InnovationLabel2', 1, {opacity: 0})
        .to('#banner3, #InnovationLabel3', 1, {opacity: 1}, '-=1')
        .to('#banner3, #InnovationLabel3', 5, {opacity: 1})
        .to('#banner3, #InnovationLabel3', 1, {opacity: 0})
        .to('#banner1, #InnovationLabel1', 1, {opacity: 1}, '-=1')
    },
    scrollToSection (section) {
      // console.log('Attempting to scroll to ' + section + ' section...')
      if (section) {
        var desiredSection = document.getElementById(section)
        // console.log('Section = ')
        // console.log(desiredSection)
        if (desiredSection) {
          desiredSection.scrollIntoView()
        }
      }
    }
  },
  beforeMount () {},
  mounted () {
    this.rotateBanner()
    // console.log('Section = ' + this.$route.params.section)
    this.scrollToSection(this.$route.params.section)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
